<script setup>
import { computed } from 'vue';

const props = defineProps({
  modelValue: {
    type: [String, Number, Boolean],
    required: true,
  },
  options: {
    type: Array,
    required: true,
    validator: (options) => {
      return options.every((option) => 
        'id' in option && 
        ('name' in option || 'label' in option)
      );
    },
  },
  name: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:modelValue']);

const updateModelValue = (value) => {
  emit('update:modelValue', value);
};

const getOptionLabel = (option) => {
  return option.name || option.label;
};
</script>

<template>
  <div class="space-y-2">
    <div 
      v-for="option in options" 
      :key="option.id" 
      class="flex items-center"
    >
      <label class="relative flex items-center cursor-pointer">
        <input
          :checked="modelValue === option.id"
          type="radio"
          :value="option.id"
          :name="name"
          :disabled="disabled"
          class="peer sr-only"
          @change="updateModelValue(option.id)"
        />
        <span 
          class="w-4 h-4 border rounded-full border-n-slate-6 flex-shrink-0 transition-all duration-200
                 flex items-center justify-center
                 peer-checked:border-n-brand
                 peer-disabled:opacity-50 peer-disabled:cursor-not-allowed"
          :class="{
            'border-n-brand': modelValue === option.id,
          }"
        >
          <span 
            class="w-2 h-2 rounded-full bg-n-brand opacity-0 transition-opacity duration-200"
            :class="{
              'opacity-100': modelValue === option.id,
            }"
          ></span>
        </span>
        <span class="ml-2 text-sm text-n-slate-12">{{ getOptionLabel(option) }}</span>
      </label>
    </div>
  </div>
</template>